import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { withStyles } from 'vopay';
import { useAlertDialog } from '@/providers/AlertDialog.provider';
import { IntegrationCardData } from './types';
import styles from './useIntegrationUpgradeDialog.module.scss';

const cn = withStyles(styles);

/**
 * Locked-card upgrade dialogue: the clicked integration's logo, name and description, with
 * "Maybe Later" / "Contact Support". Contact Support opens the support ticket form with the
 * integration named in the subject (same contract as the generic LockedFeatureDialogue).
 */
export default function useIntegrationUpgradeDialog() {
  const history = useHistory();
  const alertDialog = useAlertDialog();
  const { t } = useTranslation('translations', { keyPrefix: 'Hooks.UseIntegrationUpgradeDialog' });
  const { t: tGlobal } = useTranslation('translations', { keyPrefix: 'Global' });
  // Catalogue copy resolves against a root t with full keys (see types.ts)
  const { t: tRoot } = useTranslation();

  return async function openUpgradeDialog({ name, logo, description }: IntegrationCardData) {
    const result = await alertDialog.open(name, description(tRoot), {
      className: cn('dialog'),
      top: <img className={cn('logo')} src={logo} alt="" />,
      abortLabel: tGlobal('Buttons.maybeLater'),
      confirmLabel: tGlobal('Buttons.contactSupport'),
    });

    if (result !== 'confirm') return;

    history.push({
      pathname: '/create-tickets',
      // The ticket form caps the subject at 50 characters, so keep it short
      state: {
        ticketSubject: t('ticketSubject', {
          defaultValue: 'Enquiry about {{integration}}',
          integration: name,
        }),
      },
    });
  };
}
